const phoneNumModel = {
    id: "phoneNum",
    fields: {
        phoneNum: "phoneNum",
        whatsappUpdatesEnabled: "whatsappUpdatesEnabled"
    }
};

export { phoneNumModel };
//# sourceMappingURL=phoneNumModel.js.map
